export function WistiaEmbed({ id, title, testId }) {
  return (
    <div data-testid={testId} className="relative w-full overflow-hidden rounded-xl bg-navy" style={{ paddingTop: "56.25%" }}>
      <iframe
        src={`https://fast.wistia.net/embed/iframe/${id}?videoFoam=true&playerColor=F2005E`}
        title={title}
        allow="autoplay; fullscreen"
        allowFullScreen
        loading="lazy"
        className="absolute inset-0 h-full w-full border-0"
      />
    </div>
  );
}
